import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IhasSearchParams {
  HasInSectionsSearchParam: boolean;
  HasNotInSectionsSearchParam: boolean;
  HasInTagsSearchParam: boolean;
  HasNotInTagsSearchParam: boolean;
  HasOtherSearchParam: boolean;
}

const initialState: IhasSearchParams = {
  HasInSectionsSearchParam: false,
  HasNotInSectionsSearchParam: false,
  HasInTagsSearchParam: false,
  HasNotInTagsSearchParam: false,
  HasOtherSearchParam: false,
};

type BodyType = {
  key: string;
  value: boolean;
};

export const hasSearchParamFlags = createSlice({
  name: "hasSearchParamFlagsSlice",
  initialState,
  reducers: {
    updateSearchParamFlags: (state: any, action: PayloadAction<BodyType>) => {
      // console.log("SEARCH:", action.payload.key, ":", action.payload.value);
      state[action.payload.key] = action.payload.value;
    },

    resetSearchParamFlags: () => initialState,
  },
});

export const { updateSearchParamFlags, resetSearchParamFlags } =
  hasSearchParamFlags.actions;

export default hasSearchParamFlags.reducer;
